function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var regexp = /\${(.*)}/g;

var createFormatterSettings = function createFormatterSettings(formatValue, variableType) {
  var precision = null;
  var operation = null;
  var value = null;
  var separator = null;
  var dateFormat = null;
  var timeFormat = null;

  if (!formatValue) {
    return {
      variableType: variableType,
      prefix: null,
      suffix: null,
      precision: precision,
      operation: operation,
      value: value,
      separator: separator,
      dateFormat: dateFormat,
      timeFormat: timeFormat
    };
  }

  var _formatValue$split = formatValue.split(regexp),
      _formatValue$split2 = _slicedToArray(_formatValue$split, 3),
      prefix = _formatValue$split2[0],
      pattern = _formatValue$split2[1],
      suffix = _formatValue$split2[2];

  if (pattern) {
    var _pattern$split = pattern.split(';'),
        _pattern$split2 = _toArray(_pattern$split),
        additionalParameters = _pattern$split2.slice(1);

    if (variableType === 'number') {
      var _additionalParameters = _slicedToArray(additionalParameters, 3),
          formatPrecision = _additionalParameters[0],
          formatOperation = _additionalParameters[1],
          _formatValue = _additionalParameters[2];

      if (formatPrecision) {
        var precisionArr = formatPrecision.trim().split(',');
        precision = precisionArr[precisionArr.length - 1];
        separator = precisionArr.length > 1;
      }

      operation = formatOperation ? formatOperation.trim() : null;
      value = _formatValue ? _formatValue.trim() : null;
    } else if (variableType === 'datetime') {
      var _additionalParameters2 = _slicedToArray(additionalParameters, 2),
          datePattern = _additionalParameters2[0],
          timePattern = _additionalParameters2[1];

      dateFormat = datePattern;
      timeFormat = timePattern;
    }
  }

  return {
    variableType: variableType,
    prefix: prefix,
    suffix: suffix,
    precision: precision,
    operation: operation,
    value: value,
    separator: separator,
    dateFormat: dateFormat,
    timeFormat: timeFormat
  };
};

export default createFormatterSettings;